import { Play, Apple } from "lucide-react";
import { PLAY_STORE_URL, APP_STORE_URL } from "@/config";

const BASE = "inline-flex items-center gap-3 rounded-lg border px-4 transition-colors duration-200";

const StoreBadges = ({ compact = false, testIdPrefix = "store" }) => {
  const pad = compact ? "py-2" : "py-3";
  return (
    <div className="flex flex-wrap items-center gap-3">
      <a
        data-testid={`${testIdPrefix}-google-play-badge`}
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`${BASE} ${pad} border-linestrong bg-surface2 hover:border-brand-light hover:bg-surface3`}
      >
        <Play className="h-6 w-6 fill-onsurface text-onsurface" />
        <span className="flex flex-col leading-tight text-left">
          <span className="text-[10px] uppercase tracking-wider text-onsurface2">Get it on</span>
          <span className="font-display text-base font-semibold tracking-wide text-onsurface">Google Play</span>
        </span>
      </a>

      {APP_STORE_URL ? (
        <a
          data-testid={`${testIdPrefix}-app-store-badge`}
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={`${BASE} ${pad} border-linestrong bg-surface2 hover:border-brand-light hover:bg-surface3`}
        >
          <Apple className="h-6 w-6 text-onsurface" />
          <span className="flex flex-col leading-tight text-left">
            <span className="text-[10px] uppercase tracking-wider text-onsurface2">Download on the</span>
            <span className="font-display text-base font-semibold tracking-wide text-onsurface">App Store</span>
          </span>
        </a>
      ) : (
        <span
          data-testid={`${testIdPrefix}-app-store-badge`}
          aria-disabled="true"
          title="Coming soon"
          className={`${BASE} ${pad} cursor-not-allowed select-none border-line bg-surface2 opacity-50`}
        >
          <Apple className="h-6 w-6 text-onsurface2" />
          <span className="flex flex-col leading-tight text-left">
            <span className="text-[10px] uppercase tracking-wider text-onsurface2">Coming soon on the</span>
            <span className="font-display text-base font-semibold tracking-wide text-onsurface2">App Store</span>
          </span>
        </span>
      )}
    </div>
  );
};

export default StoreBadges;
